import pattern_16 from '../assets/images/background/pattern-16.png';
import servicesOgImage from '../assets/images/main-slider/web-development-hero.png';
import { Helmet } from "react-helmet-async";

const Service_top = ({ }) => {
    const canonical = "https://www.swiftmazetech.com/services/";
    const ogImage = `https://www.swiftmazetech.com${servicesOgImage}`;
    const description = "Explore SwiftMaze Tech's technology services including web development, software solutions, ERP, CRM, automation and digital marketing for modern businesses.";

    return (
        < >
            <Helmet>
                <title>Technology & Digital Services | Web, Software, ERP & CRM</title>
                <meta
                    name="description"
                    content={description}
                />
                <meta name="robots" content="index,follow" />
                <link rel="canonical" href={canonical} />
                <meta property="og:title" content="Technology & Digital Services | Web, Software, ERP & CRM" />
                <meta property="og:description" content={description} />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={ogImage} />
                <meta property="og:url" content={canonical} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Technology & Digital Services | Web, Software, ERP & CRM" />
                <meta name="twitter:description" content={description} />
                <meta name="twitter:image" content={ogImage} />
            </Helmet>
            <section className="page-title">
                <div className="pattern-layer-one" style={{ backgroundImage: `url(${pattern_16})` }}></div>
                <div className="auto-container">
                    <h2>SERVICES</h2>
                    <ul className="page-breadcrumb">
                        <li><a href="/">Home</a></li>
                        <li>Services</li>
                    </ul>
                </div>

            </section>
        </>
    );
};

export default Service_top;
